import { render, staticRenderFns } from "./image-banner.vue?vue&type=template&id=0ee664a2&scoped=true&"
import script from "./image-banner.vue?vue&type=script&lang=js&"
export * from "./image-banner.vue?vue&type=script&lang=js&"
import style0 from "./image-banner.vue?vue&type=style&index=0&id=0ee664a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee664a2",
  null
  
)

export default component.exports